import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=22e787ea&scoped=true&"
import script from "./ActionCard.vue?vue&type=script&lang=ts&"
export * from "./ActionCard.vue?vue&type=script&lang=ts&"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=22e787ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e787ea",
  null
  
)

export default component.exports